//Hold plan creation modal
import React, { useState, useContext, useEffect } from 'react';
import { TeamContext } from '../../../../context/TeamContext';
import { UserContext } from '../../../../context/AuthContext';
import { ModalContext } from '../../../../context/ModalContext';
import { Box, Stack } from '@mui/material';
import Modal from "react-modal";
import { db } from '../../../../firebase';
import { setDoc, doc, addDoc, collection, getDoc, updateDoc, deleteDoc } from 'firebase/firestore';
 
export default function UpdatePlan({ isOpen, onCancel, setIsUpdatePlan, teamPlans, setTeamPlans }) {

    const { currentUser, userRole, teamID } = useContext(UserContext);
    const { teamName, members } = useContext(TeamContext);
    const { updatePlanData, updatePlanIndex, setUpdatePlanIndex } = useContext(ModalContext);

    useEffect(() => {
        if (updatePlanData) {
            console.log("updatePlandata: " + JSON.stringify(updatePlanData));
            setPlanName(updatePlanData.planTitle);
            setDescription(updatePlanData.description);
            setSelected(updatePlanData.members);
        }
    }, [updatePlanData])
    
    const [planName, setPlanName] = useState('');
    const [description, setDescription] = useState('');
    const [selected, setSelected] = useState([]);
    const [noName, setNoName] = useState(false);
    const customStyles = {
        content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "30rem",
            width: "100%",
        },
    };
    const handlePlanNameChange = (event) => {
        const newName = event.target.value;
        setPlanName(newName);
    }
    const handleDescriptionChange = (event) => {
        const newDescription = event.target.value
        setDescription(newDescription);
    }
    const handleUpdatePlan = async () => {
        if (planName !== '') {
            if (userRole === 1) {
                try {
                    const teamDocRef = doc(db, "teams", teamID);
                    const teamDocSnap = await getDoc(teamDocRef);
                    const trainingPlanDocRef = doc(db, 'teams', teamID, 'training plans', updatePlanData.planID);
                    if (teamDocSnap.exists()) {
                        const teamData = teamDocSnap.data();
                        console.log(teamData);
                        const newPlanData = {
                            planID: updatePlanData.planID,
                            planCreatorName: currentUser.firstName,
                            planCreatorID: currentUser.userID,
                            planTitle: planName,
                            description: description,
                            members: selected,
                            linkedTeamID: teamID,
                            linkedTeamName: teamName,
                            planWorkouts: updatePlanData.planWorkouts,
                        }
                        const trainingPlans = teamData.trainingPlans || [];

                        trainingPlans[updatePlanIndex] = {
                            planCreatorName: updatePlanData.planCreatorName,
                            planID: updatePlanData.planID,
                            planTitle: planName,
                            linkedTeamID: teamID,
                            linkedTeamName: teamName
                        }
                        await updateDoc(trainingPlanDocRef, newPlanData)
                        await updateDoc(teamDocRef, {trainingPlans})
                        setIsUpdatePlan(false);
                        setUpdatePlanIndex(null);
                    }
                } catch (err) {
                    console.error(err);
                }   
        
            } else {
                try {
                    const userDocRef = doc(db, "users", currentUser.userID);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        const trainingPlanCollectionRef = collection(db, 'users', currentUser.userID, "training plans");
                        const userData = userDocSnap.data();
                        console.log(userData);
                        const newUserData = {
                            planCreatorName: currentUser.firstName,
                            planCreatorID: currentUser.userID,
                            planTitle: planName,
                            description: description,
                            planWorkouts: [],
                        }
                        const newTrainingPlan = await addDoc(trainingPlanCollectionRef, newUserData);
                        const planID = newTrainingPlan.id;
                        const trainingPlanDocRef = doc(trainingPlanCollectionRef, planID);
                        const trainingPlanDocSnap = await getDoc(trainingPlanDocRef);
                        if (trainingPlanDocSnap.exists()) {
                            await setDoc(trainingPlanDocRef, {planID: planID}, {merge: true})
                        }
                        const trainingPlans = userData.trainingPlans || [];
                        console.log(trainingPlans)
                        const denomalizedTeamData = [...trainingPlans , {
                            planCreatorName: currentUser.firstName,
                            planID: planID,
                            planTitle: planName,
                            linkedTeamID: null,
                            linkedTeamName: null
                        }]
                        console.log(denomalizedTeamData);
                        const data = {
                            trainingPlans: denomalizedTeamData,
                        }
                        console.log(data)
                        await setDoc(userDocRef, data, {merge: true})
                        setIsUpdatePlan(false);
                    }
                } catch (err) {
                    console.error(err);
                }   
            }    
        } else {
            setNoName(true);
        }
    }
    const addMember = (member) => {
        console.log("ADDMEMBER")
        const index = selected.findIndex(person => person.userID === member.userID);

        if (index !== -1) {
            const newSelectedArray = selected.filter((_, i) => i !== index);

            setSelected(newSelectedArray);
        } else {
            setSelected(prevSelected => [...prevSelected, member]);
        }
    };

    const handleDeletePlan = async () => {
        const teamDocRef = doc(db, "teams", teamID);
        const teamDocSnap = await getDoc(teamDocRef);
        if (teamDocSnap.exists()) {
            const data = teamDocSnap.data();
            const trainingPlans = data.trainingPlans;
            const teamTrainings = data.teamTrainings;
            const deletePlan = updatePlanData.planID;
            const newTrainingPlans = trainingPlans.filter(plan => plan.planID !== deletePlan);
            const newTeamTrainings = teamTrainings.filter(training => training.linkedPlanID !== deletePlan);
            const updatedData = {
                teamTrainings: newTeamTrainings,
                trainingPlans: newTrainingPlans,
            }
            const newTeamPlans = teamPlans.filter(plan => plan.planID !== deletePlan);
            await updateDoc(teamDocRef, updatedData);
            const planDocRef = doc(db, "teams", teamID, "training plans", deletePlan);
            await deleteDoc(planDocRef);
            setTeamPlans(newTeamPlans);
            setIsUpdatePlan(false);
        }
    }
    useEffect(() => {
        console.log("Selected: " + JSON.stringify(selected));
    }, [selected])
    const handleClose = () => {
        onCancel();
    };
    return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Modal
                isOpen={isOpen}
                onRequestClose={handleClose}
                style={customStyles}
                contentLabel="Modal"
                className="create-team-content"
                overlayClassName="create-team-overlay"
                ariaHideApp={false} // Opt-out of accessibility settings
                >
                <Stack direction="column" spacing={1}>
                    {userRole === 1 ? (
                        <Stack direction='row' justifyContent='space-between' alignItems='center'>
                            <text className='small-medium white'>
                                Plan For {teamName}
                            </text>
                            <button className='small delete-red text-button' onClick={handleDeletePlan}>
                                delete
                            </button>
                        </Stack>
                    ):(
                        <text className='small-medium white'>
                            Update Personal Plan
                        </text>
                    )}
                    {noName && <text className='delete-red small'>*Must Enter in a name</text>}
                    <div 
                        className='page-border-line'
                        />
                    <input 
                        className='workout-name-input border-outline white small-medium'   
                        placeholder='Untitled Plan'
                        onChange={handlePlanNameChange}
                        value={planName}
                        />
                    <div 
                        className='page-border-line'
                        />
                    <textarea 
                        className='plan-description white small'
                        placeholder='//Add Description'
                        onChange={handleDescriptionChange}
                        value={description}
                    />
                    <div 
                        className='page-border-line'
                    />
                    {selected && userRole === 1 && (
                        <Stack direction='column' spacing={1}>
                            <text className='very-small light-grey'> Plan Roster</text>
                            {members.length > 1 ? members.map((member, index) => {
                                if (member.accountType === 0) {
                                    return (
                                        <Stack key={index} direction='row' spacing={7}  className='select-plan-roster'>
                                            {selected.some(person => person.userID === member.userID) ? (
                                                <div className='roster-select-selected' onClick={() => addMember(member)} />
                                            ) : (
                                                <div className='roster-select' onClick={() => addMember(member)} />
                                            )}
                                            <text className='white small'>{member.firstName} {member.lastName}</text>
                                        </Stack>
                                    )
                                }}) : (
                                    <text className='small white'>No Members</text>
                                )}
                            <div 
                                className='page-border-line'
                            />
                        </Stack>
                    )}
                    <button 
                        className='border-outline submit-green create-workout-button'
                        onClick={handleUpdatePlan}
                        >
                        Update Plan
                    </button>
                </Stack>
            </Modal>
        </Box>
    )
}
 